import { useState, useEffect } from 'react';
import axios from 'axios';
import './istoryBoard.css';
import Header from "../components/Header";
import { Container, Box, Modal,Grid, Fade, Backdrop, Typography, TextField, Button, CircularProgress } from '@mui/material';
import { motion } from 'framer-motion';
import CustomToolbar from '../components/toolbar';
import SceneDisplay from '../components/sceneDisplay';
import { useNavigate } from "react-router-dom";
import { decodeToken } from "react-jwt";
import TitleDisplay from "../components/title"
import jwtDecode from 'jwt-decode';
import {HoopSpinner} from "react-spinners-kit"
import {data,data1,data2} from "./data.js"
import car_scene_0_dialogue_0 from "../assets/project/cars/scene_0/dialog_0.wav"
import car_scene_0_dialogue_1 from "../assets/project/cars/scene_0/dialog_1.wav"
import car_scene_1_dialogue_0 from "../assets/project/cars/scene_1/dialog_0.wav"
import car_scene_1_dialogue_1 from "../assets/project/cars/scene_1/dialog_1.wav"
import car_scene_2_dialogue_0 from "../assets/project/cars/scene_2/dialog_0.wav"
import car_scene_2_dialogue_1 from "../assets/project/cars/scene_2/dialog_1.wav"
import flower_scene_0_dialogue_0 from "../assets/project/flower/scene_0/dialog_0.wav"
import flower_scene_0_dialogue_1 from "../assets/project/flower/scene_0/dialog_1.wav"
import flower_scene_1_dialogue_0 from "../assets/project/flower/scene_1/dialog_0.wav"
import flower_scene_1_dialogue_1 from "../assets/project/flower/scene_1/dialog_1.wav"
import flower_scene_2_dialogue_0 from "../assets/project/flower/scene_2/dialog_0.wav"
import flower_scene_2_dialogue_1 from "../assets/project/flower/scene_2/dialog_1.wav"
import tea_scene_0_dialogue_0 from "../assets/project/tea/scene_0/dialog_0.wav"
import tea_scene_0_dialogue_1 from "../assets/project/tea/scene_0/dialog_1.wav"
import tea_scene_1_dialogue_0 from "../assets/project/tea/scene_1/dialog_0.wav"
import tea_scene_1_dialogue_1 from "../assets/project/tea/scene_1/dialog_1.wav"
import tea_scene_2_dialogue_0 from "../assets/project/tea/scene_2/dialog_0.wav"
import tea_scene_2_dialogue_1 from "../assets/project/tea/scene_2/dialog_1.wav"
import car1 from '../assets/project/cars/iStory_Img-3672d8a91b824a2dad5eac064b7ae551-xl.png'
import car2 from '../assets/project/cars/iStory_Img-68e09f700cca48249f178a33a23a070a-xl.png'
import car3 from '../assets/project/cars/iStory_Img-ba1448de3a0f4c769c53fb7ebb3f491f-xl.png'
import flower1 from '../assets/project/flower/iStory_Img-599b55ca45834432990e07f9a898a4a1-xl.png'
import flower2 from '../assets/project/flower/iStory_Img-f53f560651aa4b3e9069aee92f07822a-xl.png'
import flower3 from '../assets/project/flower/iStory_Img-d9cbca3dade34c4c8c605da0c017f78d-xl.png'
import tea1 from '../assets/project/tea/iStory_Img-34dba5bab5884de3a5b9f54cb1cf77b2-xl.png'
import tea2 from '../assets/project/tea/iStory_Img-e70b51ecf1a0461985cec80ec72399c8-xl.png'
import tea3 from '../assets/project/tea/iStory_Img-efc5f5e11db84a6599133f0176883230-xl.png'
import { LinearProgress } from '@mui/material';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 370,
    // bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    backgroundColor: '#141313'
  };

let language = [{ language: "English (United States)", code: "en-US" }, { language: "English (United Kingdom)", code: "en-GB" }, { language: "English (Australia)", code: "en-AU" }]
let voice = [
   { 
    gender:"Female",
    voice: "Aria", 
    code: "en-US-AriaNeural", 
    language: 0 },
  //  { 
  //   gender:"Female",
  //   voice: "Jenny", 
  //   code: "en-US-JennyNeural", 
  //   language: 0 },
  //  { 
  //   gender:"Male",
  //   voice: "Guy", 
  //   code: "en-US-GuyNeural", 
  //   language: 0 },
  //  { 
  //   gender:"Female",
  //   voice: "Sara", 
  //   code: "en-US-SaraNeural", 
  //   language: 0 },
  //  { 
  //   gender:"Male",
  //   voice: "Brandon", 
  //   code: "en-US-BrandonNeural", 
  //   language: 0 },
  //   { 
  //     gender:"Female",
  //     voice: "Libby", 
  //     code: "en-GB-LibbyNeural", 
  //     language: 1 },
   
    // { 
    //   gender:"Female",
    //   voice: "Sonia", 
    //   code: "en-GB-SoniaNeural", 
    //   language: 1 },
    // { 
    //   gender:"Male",
    //   voice: "Ryan", 
    //   code: "en-GB-RyanNeural", 
    //   language: 1 },
    // { 
    //   gender:"Female",
    //   voice: "Mia", 
    //   code: "en-GB-MiaNeural", 
    //   language:1 },
    { 
      gender:"Female",
      voice: "Natasha", 
      code: "en-AU-NatashaNeural", 
      language: 2 },
    // { 
    //   gender:"Male",
    //   voice: "William", 
    //   code: "en-AU-WilliamNeural", 
    //   language: 2 },
    // { 
    //   gender:"Female",
    //   voice: "Catherine", 
    //   code: "en-AU-Catherine", 
    //   language: 2 },
    // { 
    //   gender:"Female",
    //   voice: "Hayley", 
    //   code: "en-AU-HayleyRUS", 
    //   language: 2 },
 
  ]
const API_BASE = "https://controllayer-prod.azurewebsites.net/account/creative/";
//const API_BASE = "http://127.0.0.1:8000/account/creative/";
const IstoryBoard = () => {
  const navigate = useNavigate();
  const [storyIntent, setStoryIntent] = useState("");
  const [responseData, setResponseData] = useState([]);
  const [currentScene, setCurrentScene] = useState(0);
  const [isInputFocused, setInputFocused] = useState(false);
  const [open, setOpen] = useState(false);
  const [creative_open, setCreativeOpen] = useState(false);
  const [error, setErrorMessage] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [token, setToken] = useState(null);
  const [creativex,setCreativeX] = useState(false);
  const [previewiStoryBtn, setPreviewiStoryBtn] = useState(false);
  const [istoryId, setIstoryId] = useState(null);
  const [dialogLoader, setDialogLoader] = useState(false)
  const [dialogs, setDialog] = useState()
  const [title, setTitle] = useState([])
  const [selecetdVoice,setSelectedVoice]=useState()
  const [selecetdLanguage,setSelectedLanguage]=useState("en-US")
  const [lisVoice,setListVoice]=useState([])
  const [listLanguage,setListLanguage]=useState([])
  const [storyCretionError,setStoryCreationError]=useState()
  const [counter,setCounter]=useState()
  const [assets,setAsset]=useState([])
  const [lastPanel,setLastPanel]=useState(false);
  const [api_usage,setApi_usage]=useState(0)
  const [storyCreateFailed, setStoryCreateFailed] = useState(false);


  const handlenavigateHome=()=>{
    navigate('/')

  }
  // const [restrictionOpen,setRestrictionOpen] = useState(false)

    // useEffect(() => {
        
    //     const storedToken = localStorage.getItem('token');
    //     // console.log("coming",jwtDecode(storedToken).user_api_usage.istory)
    //     if (storedToken) {
    //       setToken(storedToken);
    //       // setApi_usage(jwtDecode(storedToken).user_api_usage.istory)
    //     } else {
            
    //         // Redirect to login page
    //         navigate("/login");
    //     }
    //   }, []);

    const handleOpen = () => {
     
        setOpen(true)
      
    };
    const handleCreateOpen = () => {
     
      setCreativeOpen(true)
      setCreativeX(true)
    
  };

    const handleClose = () => setOpen(false);
    const handleCreativeClose = () => setCreativeOpen(false);

    // const RestrictionhandleClose = () => setRestrictionOpen(false);

    const handleInputFocus = () => setInputFocused(true);
    
    const handleInputBlur = () => setInputFocused(false);

  const handleSceneChange = (sceneNumber) => {
    setCurrentScene(sceneNumber);
    setSelectedLanguage(responseData[sceneNumber].description[0].language)

  };

    const handleSaveScene = async (e) => {
        e.preventDefault(); // 👈️ prevent page refresh
        setLoading(true);
        let story_id;
        let asset=[];

        //create istory

        const storyPayload = {
            name: "iStoryAssitiveCampaignDemo",
            status: "PUBLISHED",
            active: false,
            studio_user_id:798
        };

        /////////////////asset creation////////////////

        // const token=window.localStorage.getItem("token")
        // const user=decodeToken(token).user_id
        const assetPayload = {
          asset:responseData,
          user:798
        }
         const assetCars = [{image: 'https://playground.arivu-iq.com'+car1, dialogs: ['https://playground.arivu-iq.com'+car_scene_0_dialogue_0,'https://playground.arivu-iq.com'+car_scene_0_dialogue_1], caption: ['Porsche is more than just a brand of cars. It represents the pinnacle of automotive engineering, luxury, and performance. With a rich heritage and a commitment to excellence, Porsche continues to push the boundaries of what is possible in the world of automobiles.', 'From iconic sports cars to luxurious sedans, each Porsche model is meticulously crafted with precision and attention to detail. With cutting-edge technology and unparalleled craftsmanship, our cars are designed to deliver an extraordinary driving experience.']}, {image: 'https://playground.arivu-iq.com'+car2, dialogs: ['https://playground.arivu-iq.com'+car_scene_1_dialogue_0, 'https://playground.arivu-iq.com'+car_scene_1_dialogue_1], caption: ['At Porsche, we believe that every drive should be an unforgettable experience. Our cars combine luxurious interiors with exhilarating performance to create a harmonious balance between comfort and excitement.', "Step inside a Porsche car and you will be greeted by premium materials, ergonomic design, and state-of-the-art features that elevate your driving experience. From the moment you start the engine, you will feel the power at your fingertips as you accelerate through breathtaking speeds."]}, {image: 'https://playground.arivu-iq.com'+car3, dialogs: ['https://playground.arivu-iq.com'+car_scene_2_dialogue_0, 'https://playground.arivu-iq.com'+car_scene_2_dialogue_1], caption: ["For those who crave speed and adrenaline-fueled thrills, Porsche offers unrivaled performance that will ignite your passion for driving. Our sports cars are engineered for maximum power and agility.", "With exceptional handling capabilities and lightning-fast acceleration times, a drive in a Porsche car is like no other. Whether you're conquering winding mountain roads or tearing up the racetrack, our vehicles are designed to unleash your inner speed demon and deliver an exhilarating driving experience."]}]
        const assetflower = [{image: 'https://playground.arivu-iq.com'+flower1, dialogs: ['https://playground.arivu-iq.com'+flower_scene_0_dialogue_0, 'https://playground.arivu-iq.com'+flower_scene_0_dialogue_1], caption: ['Welcome to our Colorful Bouquet Shop, where beauty and nature come together in a vibrant display of flowers. Step into our shop and be greeted by a kaleidoscope of colors, fragrances, and textures that will captivate your senses.', 'We take pride in curating the finest selection of blooms from around the world, ensuring that each bouquet is a work of art that conveys your emotions and brightens any occasion.']}, {image: 'https://playground.arivu-iq.com'+flower2, dialogs: ['https://playground.arivu-iq.com'+flower_scene_1_dialogue_0, 'https://playground.arivu-iq.com'+flower_scene_1_dialogue_1], caption: ['At our Colorful Bouquet Shop, we believe that flowers have the power to convey emotions like no other gift. From cheerful yellows to passionate reds, serene whites to vibrant purples, we offer a rainbow of blooms for every sentiment and celebration.', "Our expert florists handpick each bloom with care and arrange them into stunning bouquets that reflect your unique style and personality. Whether you're expressing love, gratitude, or sympathy, let our colorful blooms speak for you."]}, {image: 'https://playground.arivu-iq.com'+flower3, dialogs: ['https://playground.arivu-iq.com'+flower_scene_2_dialogue_0, 'https://playground.arivu-iq.com'+flower_scene_2_dialogue_1], caption: ["Looking for a way to brighten someone's day? Look no further than our Colorful Bouquet Shop. Our exquisite bouquets are designed to bring joy and happiness into people's lives.", "Whether it's surprising your loved ones on special occasions or simply showing someone you care, our bouquets are sure to make their day extra special. Each arrangement is carefully crafted with fresh flowers that radiate beauty and positivity."]}]
        const assetTea = [{image: 'https://playground.arivu-iq.com'+tea1, dialogs: ['https://playground.arivu-iq.com'+tea_scene_0_dialogue_0, 'https://playground.arivu-iq.com'+tea_scene_0_dialogue_1], caption: ['Indulge in the rich and robust flavors of the classic black tea. Made from fully oxidized tea leaves, black tea offers a bold and satisfying taste that is perfect for starting your day or enjoying as an afternoon pick-me-up. With its deep amber color and invigorating aroma, black tea is a timeless favorite for tea enthusiasts.', 'Whether you prefer it plain or with a splash of milk and sugar, the classic black tea is sure to awaken your senses and leave you feeling refreshed.']}, {image: 'https://playground.arivu-iq.com'+tea2, dialogs: ['https://playground.arivu-iq.com'+tea_scene_1_dialogue_0, 'https://playground.arivu-iq.com'+tea_scene_1_dialogue_1], caption: ['Experience the natural goodness of green tea. Known for its fresh and delicate flavor, green tea is made from unoxidized leaves that are carefully picked and immediately steamed or pan-fired to preserve their vibrant color and distinct taste. Savor the light grassy notes with subtle hints of sweetness as you sip on this refreshing beverage.', 'In addition to its delightful taste, green tea is also renowned for its numerous health benefits. Packed with antioxidants, it can help boost metabolism, support weight loss efforts, improve brain function, lower the risk of chronic diseases, and promote overall well-being.']}, {image: 'https://playground.arivu-iq.com'+tea3, dialogs: ['https://playground.arivu-iq.com'+tea_scene_2_dialogue_0, 'https://playground.arivu-iq.com'+tea_scene_2_dialogue_1], caption: ['Unwind with a comforting cup of herbal tea. Unlike traditional teas made from Camellia sinensis leaves (such as black or green), herbal teas are infusions made from various herbs, flowers, fruits, or spices. With their soothing properties and unique flavors, herbal teas offer a calming experience that can help you relax and unwind after a long day.', 'From chamomile and lavender to peppermint and ginger, there is a wide variety of herbal teas to choose from. Each blend has its own distinct taste profile and potential health benefits, making herbal tea a versatile choice for any occasion.']}]
        // console.log(responseData,user)
        
        // const assetResponse = await axios.post(API_BASE + 'assetcreation/', assetPayload, {
        //     headers: {
        //       'Content-Type': 'application/json',
        //     },
        // });

        if (responseData) {
          try {
            setErrorMessage("")
         
        {title[0].title==='Welcome to our Colorful Bouquet Shop'?setAsset(assetflower):title[0].title==='Introducing Porsche Cars'?setAsset(assetCars):setAsset(assetTea)}
            
            

          } catch (error) {
            setLoading(false);
          }
        } else {
          setLoading(false);
          setErrorMessage("Please try again.");
        }

        //////////////////////////////////////////////

        try {
            const storyResponse = await axios.post('https://istorydesigncenter.com/istory/list/', storyPayload, {
              headers: {
                'Content-Type': 'application/json',
              },
            });
          
            if (storyResponse.status === 201) {
              try {
                
                setErrorMessage("")
                const responseData = storyResponse.data;
                setIstoryId(responseData.id)
                setCounter(0)
                story_id = responseData.id
              } catch (error) {
                setLoading(false);
              }
            } else {
              setLoading(false);
              setErrorMessage("Please try again.");
            }
        } catch (error) {
            setLoading(false);
            setErrorMessage("An error occurred. Please try again later.");
        }

        //create istory scenes
        ///////////////////////////////////////////////////////
        // responseData.forEach(async (data, index) => {
        //   console.log("index: ", index)
        //   console.log("assets: ", asset)
        //   console.log("asset scene dialog: ", asset[index].dialogs)
        //     const scenePayload = {
        //       scene_name: `scene ${index + 1}`,
        //       scenetype: "NONINTERACTION",
        //       scene_dialogue: asset[index].dialogs.map((desc,i) => ({
        //         story_voice: "en-US-CoraNeural",
        //         dialog_text: desc,
        //         caption: asset[index].caption[i],
        //         dialog_pause_period: null
        //       })),
        //       interaction_from_scene: [],
        //       scene_play: "IMAGE",
        //       scene_img: asset[index].image,
        //     //   scene_img: data.image_caption,
        //       scene_video: null,
        //       navigation: null,
        //       scene_order: index + 1,
        //       story: story_id
        //     };
          
        //     try {
        //       const sceneResponse = await axios.post(`https://uat.istorydesigncenter.com/istory/${story_id}/scenes/`, scenePayload, {
        //         headers: {
        //           'Content-Type': 'application/json',
        //         },
        //       });
          
        //       if (sceneResponse.status === 201) {
        //         try {
        //           setErrorMessage("");
        //           const responseData = sceneResponse.data;console.log("parsed data from scene creating api", responseData);
        //         } catch (error) {console.error('Error parsing response data:', error);
        //           setLoading(false);
        //         }
        //       } else {
        //         setLoading(false);
        //         setErrorMessage("Please try again.");
        //       }
              
        //     } catch (error) {
        //       setLoading(false);
        //       setErrorMessage("An error occurred. Please try again later.");
        //     }
        //   });
        //////////////////////////////////////////////////////
        // setLoading(false);
        // setPreviewiStoryBtn(true);
    };

    // console.log(dialogs)
    const scene_saving= async ()=>{
     if (counter<responseData.length) {
      // console.log("before scene creation api")
      const scenePayload = {
        scene_name: `scene ${counter + 1}`,
        scenetype: "NONINTERACTION",
        scene_dialogue: assets[counter].dialogs.map((desc,i) => ({
          story_voice: "en-US-CoraNeural",
          dialog_text: desc,
          caption: assets[counter].caption[i],
          dialog_pause_period: null
        })),
        interaction_from_scene: [],
        email_interaction_scene: [],
        scene_play: "IMAGE",
        scene_img: assets[counter].image,
      //   scene_img: data.image_caption,
        scene_video: null,
        navigation: null,
        scene_order: counter + 1,
        story: istoryId
      };
      // console.log("scene payload", scenePayload)
    
      try {
        const sceneResponse = await axios.post(`https://istorydesigncenter.com/istory/${istoryId}/scenes/`, scenePayload, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
    
        if (sceneResponse.status === 201) {
          try {
            setErrorMessage("");
            const responseData = sceneResponse.data;
            // console.log("parsed data from scene creating api", responseData);
            setCounter(counter+1)
          } catch (error) {console.error('Error parsing response data:', error);
            setLoading(false);
          }
        } else {
          setLoading(false);
          setErrorMessage("Please try again.");
        }
        
      } catch (error) {
        setLoading(false);
        setErrorMessage("An error occurred. Please try again later.");
      }

      }
      
    
  //////////////////////////////////////////////////////
  else{
    setLoading(false);
  setPreviewiStoryBtn(true);

  }
  

    }
    useEffect(()=>{
      scene_saving()

    },[counter,istoryId,assets])
    const parsedData = []
    const [ttl,setTTl] = useState("")
 
      
    {ttl==="Porsche car campaign"  && parsedData.push({"id":"1","title":"Introducing Porsche Cars"},{"id":"2","title":"Experience Luxury and Performance"},{"id":"3","title":"Unleash Your Inner Speed Demon"})}  
    {ttl==="Colorful bouquet shop campaign"  && parsedData.push({"id":"1","title":"Welcome to our Colorful Bouquet Shop"},{"id":"2","title":"A Rainbow of Blooms"},{"id":"3","title":"Brighten Your Day with Our Bouquets"})}  
    {ttl==="Types of tea"  && parsedData.push({"id":"1","title":"The Classic Black Tea"},{"id":"2","title":"The Refreshing Green Tea"},{"id":"3","title":"The Soothing Herbal Tea"})}  

    const handlePreviewiStory = (event) => {
      if (!istoryId) {
        alert("The iStory is still loading. Please try again in a moment.");
        return;
      }
      

      window.open(`https://cx.intelligentx.arivu-iq.com/?iStory_id=${istoryId}`, "_blank");
    };
    // // useEffect(()=>{
    // //     console.log("inside useeffect",istoryId)
    // //     window.open(`https://uat.istorylive.com/?iStory_id=${istoryId}`, "_blank");
    // // },[istoryId])
    // async function handleSubmit (e) {
    //     e.preventDefault(); // 👈️ prevent page refresh
    //     handleClose();
    //     setPreviewiStoryBtn(false)
    //     setLoading(true);
    //     const payload = {
    //         messages: [
    //           { role: 'user', content: storyIntent }
    //         ]
    //       };
    //     console.log("Submit");
    //     // https://demobe.nlugpt.io/copilot/version1/
    //     // https://demobe.nlugpt.io/copilot/version1/
    //     try {
    //         const response = await axios.post('https://demobe.nlugpt.io/copilot/version1/', payload, {
    //           headers: {
    //             'Content-Type': 'application/json',
    //           },
    //         });
          
    //         if (response.status === 201) {
    //           try {
    //             const parsedData = JSON.parse(response.data);
    //             console.log("parsed data", parsedData);
    //             setResponseData(parsedData);
    //             setLoading(false);
    //             setErrorMessage("")
    //           } catch (error) {
    //             console.error('Error parsing response data:', error);
    //             setLoading(false);
    //           }
    //         } else {
    //           setLoading(false);
    //           setErrorMessage("Please try again.");
    //         }
    //     } catch (error) {
    //         setLoading(false);
    //         setErrorMessage("An error occurred. Please try again later.");
    //     }
    // }
    const titleGeneration=async(e)=>{
      e.preventDefault(); // 👈️ prevent page refresh
      handleClose()
      // setLoading(true);
      // const api_usage_response = await axios.post(API_BASE + 'api_usage/',{"user_id":jwtDecode(token).user_id,"type":"istory"})
      // if((api_usage_response.status === 200 && api_usage_response.data.count >= 0 )|| api_usage_response.data.user==7){

      //   // console.log(storyIntent)
      //   const payload= {messages:[
      //       {
      //         "role": "user",
      //         "content": storyIntent
      //       }
      //     ]} 
      
      setTitle(parsedData)
          // try {
          //           const response = await axios.post(API_BASE + 'topic_generation/', payload, {
          //             headers: {
          //               'Content-Type': 'application/json',
          //             },
          //           });
                  
          //           if (response.status === 201) {
          //             try {
          //               const parsedData = JSON.parse(response.data);
          //               console.log("parsed data", parsedData);
          //               // console.log(parsedData)
                        setResponseData([]);
                      
                        
          //               setLoading(false);
          //               setErrorMessage("")
          //             } catch (error) {
          //               console.error('Error parsing response data:', error);
          //               setLoading(false);
          //             }
          //           } else {
          //             setLoading(false);
          //             setErrorMessage("Please try again.");
          //           }
          //   } catch (error) {
          //       setLoading(false);
          //       setErrorMessage("An error occurred. Please try again later.");
          //   }
      }

      const titleCreation = async (e) => {
        e.preventDefault(); // 👈 prevent page refresh
        handleCreativeClose();
        setLoading(true);
      
        try {
          const response = await axios.post(`${API_BASE}`, { "title": storyIntent }, {
            headers: {
              "Content-Type": "application/json"
            }
          });
      
          console.log(response.data);
          setTitle(response.data.title);
          setStoryCreateFailed(false); // ✅ reset failure state
          setLoading(false);
        } catch (error) {
          console.error("Title creation failed:", error);
          setStoryCreateFailed(true); // ✅ show retry UI on failure
          setLoading(true); // keep loading state so retry UI is rendered
        }
      };
      
      
    
    const modifyDialog= async(dialog,index)=>
    {
        setPreviewiStoryBtn(false)
        let payload
        if(dialog){
           payload={
            messages: dialog
        }
        
        }
        else{
           payload={
            messages: dialogs
        }
        }
        
        
        try {
            setDialogLoader(true)
        // const response=await axios.post(API_BASE + "modifyDialogue/",payload,{headers: {
        //     'Content-Type': 'application/json',
        //   }})
        // response ={}
         const length = 3
        let cars = ["From iconic sports cars to luxurious sedans, each Porschea model is meticulously crafted with precision and attention to detail. With cutting-edge technology and unparalleled craftsmanship, our cars are designed to deliver an extraordinary driving experience.","Step inside a Porschea car and you will be greeted by premium materials, ergonomic design, and state-of-the-art features that elevate your driving experience. From the moment you start the engine, you will feel the power at your fingertips as you accelerate through breathtaking speeds.","At Porschea, we believe that every drive should be an unforgettable experience. Our cars combine luxurious interiors with exhilarating performance to create a harmonious balance between comfort and excitement.","For those who crave speed and adrenaline-fueled thrills, Porschea offers unrivaled performance that will ignite your passion for driving. Our sports cars are engineered for maximum power and agility."]
        let flowers = ["Welcome to our Colorful Bouquet Shop, where beauty and nature come together in a vibrant display of flowers. Step into our shop and be greeted by a kaleidoscope of colors, fragrances, and textures that will captivate your senses.","We take pride in curating the finest selection of blooms from around the world, ensuring that each bouquet is a work of art that conveys your emotions and brightens any occasion.","At our Colorful Bouquet Shop, we believe that flowers have the power to convey emotions like no other gift. From cheerful yellows to passionate reds, serene whites to vibrant purples, we offer a rainbow of blooms for every sentiment and celebration.","Our expert florists handpick each bloom with care and arrange them into stunning bouquets that reflect your unique style and personality. Whether you're expressing love, gratitude, or sympathy, let our colorful blooms speak for you."]
        let tea = ["Indulge in the rich and robust flavors of the classic black tea. Made from fully oxidized tea leaves, black tea offers a bold and satisfying taste that is perfect for starting your day or enjoying as an afternoon pick-me-up. With its deep amber color and invigorating aroma, black tea is a timeless favorite for tea enthusiasts.","Whether you prefer it plain or with a splash of milk and sugar, the classic black tea is sure to awaken your senses and leave you feeling refreshed.","Experience the natural goodness of green tea. Known for its fresh and delicate flavor, green tea is made from unoxidized leaves that are carefully picked and immediately steamed or pan-fired to preserve their vibrant color and distinct taste. Savor the light grassy notes with subtle hints of sweetness as you sip on this refreshing beverage.","From chamomile and lavender to peppermint and ginger, there is a wide variety of herbal teas to choose from. Each blend has its own distinct taste profile and potential health benefits, making herbal tea a versatile choice for any occasion."] 
        let  response =  Math.floor(Math.random() * length )+1;
          if (response) {
            try {
              // console.log("dialogue")
                setResponseData((previous_value)=>{
                    let updateValues=[...previous_value]
                    const str =parsedData[0].title==="Introducing Porsche Cars"?cars[response].replace(/"/g,''):parsedData[0].title==="Welcome to our Colorful Bouquet Shop"?flowers[response].replace(/"/g,''):tea[response].replace(/"/g,'');
                    let replaceSelected = updateValues[currentScene].description[index].text.replace(payload.messages, str);
                    updateValues[currentScene].description[index].text = replaceSelected
                    // updateValues[currentScene].description[index].text = response.data
                    // console.log(updateValues)
                    setDialogLoader(false)
                    return updateValues
        
                })
              
              setErrorMessage("")
            } catch (error) {
              console.error('Error parsing response data:', error);
              setLoading(false);
            }
          } else {
            setResponseData((previous_value)=>{
              let updateValues=[...previous_value]
              
              updateValues[currentScene].description[index].text="Please try again."
              setDialogLoader(false)
              return updateValues
  
          })
            setLoading(false);
            setErrorMessage("Please try again.");
          }
        }
        catch(error) {
            setLoading(false);
            setResponseData((previous_value)=>{
              let updateValues=[...previous_value]
              
              updateValues[currentScene].description[index].text="An error occurred. Please try again later."
              setDialogLoader(false)
              return updateValues
  
          })
            setErrorMessage("An error occurred. Please try again later.");
        }

    }
    const dialogChange=(value,index)=>{
        // console.log(value)
        setDialog(value)
        setPreviewiStoryBtn(false)
        setResponseData((previous_value)=>{
            let updateValues=[...previous_value]
            
            updateValues[currentScene].description[index].text=value
            // setDialogLoader(false)
            return updateValues

        })
       
    }
    const deleteTitle=(index)=>{
      // setTitle((prevalues)=>{
      //   let updateValues=[...prevalues]
      //   updateValues.splice(index,1)
      //   console.log((updateValues))
      //   return updateValues
      // })

    }
    const addTitle=(index)=>{
      // let create={title:"New Title"}
      // setTitle((prevalues)=>{
      //   let updateValues=[...prevalues]
      //   updateValues.splice(index+1,0,create)
      //   console.log((updateValues))
      //   return updateValues
      // })
      
    }
    const titleChange=(value,index)=>{
    //   setTitle((previous)=>{
    //     let updateValues=[...previous]
    //     updateValues[index].title=value
    //     return updateValues

    // })
  }
  
  const createStory = async () => {
    // console.log("inside crs")
    setLastPanel(false);
    setCurrentScene(0);
    // const topics = title.map(item => `'${item.title}'`)

    // const promptText = storyIntent + ". " + "Titles are" + " " + `[${topics}]`
    // setLoading("images");
    // const payload = { "messages": [{ "role": "user", "content": promptText }] }
    try {
      // It's unclear if Axios supports streaming POST requests, so I use `fetch`.
      // const response = await fetch(API_BASE + "version1-stream/", {
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   method: "POST",
      //   body: JSON.stringify(payload),
      //   // responseType: "stream",
      // });
      setListLanguage(language);
          setListVoice(voice);
      let panels ="";
      {ttl==="Porsche car campaign"?panels=data:ttl==="Colorful bouquet shop campaign"?panels=data1:ttl==="Types of tea"?panels=data2:panels=title}
      panels.map((e)=>{
        e.description = e.description.map((text)=>({
                language: "en-US",
                voice: "en-US-AriaNeural",
                text,
        }))
      })

      if (title) {
        try {
          // const reader = response.body.getReader();
          // const decoder = new TextDecoder();
          // let streaming = "";

          

          // function readChunk() {
          //   reader.read().then(({ value, done }) => {
          //     if (done) {
          //       if (streaming !== "") newPanel()
          //       return endLoad();
          //     }
          //     const chunk = data[0];
          //     console.log(chunk)
          //     // console.log("Read chunk", chunk)
          //     // Weird behaviour where nginx doesn't process stream
          //     // chunks in the way that django sends them out ?????
          //     if (chunk.includes("}{")) {
          //       let [endOfChunk, startOfChunk] = chunk.split("}{")
          //       streaming += endOfChunk + "}";
          //       newPanel();
          //       streaming = "{" + startOfChunk;
          //     } else {
          //       streaming += chunk;
          //     }
          //     if (chunk.endsWith("}"))
          //      newPanel();
              
          //     readChunk();
          //   })
          // }
          // function newPanel() {
            // try {
              // let newPanel = [data];
              // console.log(newPanel)
              // newPanel.description = newPanel.map(text => ({
              //   language: "en-US",
              //   voice: "en-US-AriaNeural",
              //   text,
              // }));
              // panels.push(newPanel);
              // console.log(panels)
              // streaming = "";
              // All of the "last panel" stuff can be removed
              // I just haven't gotten around to doing it :(
              setLastPanel(panels.at(-1));
              setLoading(false);
              setResponseData(panels);
              setStoryCreationError("");
              setPreviewiStoryBtn(false);
             
            // } catch (e) {
            //   console.log(e, streaming);
            //   setLoading(false);
            //   setStoryCreationError("Please try again.");
            // }
          // }
          function endLoad() {
            // console.log("parsed data", language_infused);
            // setResponseData(language_infused);
            // setStoryCreationError("")
            // setPreviewiStoryBtn(false)
          }
          // readChunk();
          // stream.on("data", data => {
          //   let tmp = responseData;
          //   tmp.push(JSON.parse(data));
          //   console.log(data);
          //   setResponseData(() => tmp);
          // })
          // stream.on("end", () => {
          //   let language_infused=parsedData.map(item=>{
          //     let infused=item.description.map(text=>{
          //       let array={language:"en-US",voice:"en-US-AriaNeural",text:text}
          //       return array
          //     })
          //     setListLanguage(language)
          //     setListVoice(voice)
          //     item.description=infused
          //     return item
          //   })
          //   console.log("parsed data", language_infused);
          //   setResponseData(parsedData);
          //   setLoading(false);
          //   setStoryCreationError("")
          //   setPreviewiStoryBtn(false)
          // })
        } catch (error) {
          console.error('Error parsing response data:', error);
          setLoading(false);
        }
      } else {
        setLoading(false);
        setStoryCreationError("Please try again.");
      }
    } catch (error) {
      setLoading(false);
      // console.log("error occured", error)
      setStoryCreationError("An error occurred. Please try again later.");
    }
  }
  const selectedVoiceChange=(value,index)=>{
    setPreviewiStoryBtn(false)
    setResponseData((previous_value) => {
      let updateValues = [...previous_value]

      updateValues[currentScene].description[index].voice = value
      // setDialogLoader(false)
      // console.log(updateValues)
      return updateValues

    })
  }
  const selecetdLanguageChange=(value,index)=>{
    setPreviewiStoryBtn(false)
    // let langFilter=language.filter((item,index)=>item.code===value)
    
    // let index_number=language.indexOf(langFilter[0])
    // let voices=voice.filter(item=>item.language==index_number)
   
    // setListVoice(voices)
    setResponseData((previous_value) => {
      let updateValues = [...previous_value]

      updateValues[currentScene].description.map(element => {
        element.language = value
        // element.voice = voices[0].code
      });
      // setDialogLoader(false)
      // console.log(updateValues)
      return updateValues

    })
  }
  useEffect(()=>{
    if (responseData.length>0)
    {selecetdLanguageChange(selecetdLanguage)
    }
    
},[selecetdLanguage])
const deleteDialog=(index)=>{
  setPreviewiStoryBtn(false)
  setResponseData((prevalues)=>{
    let updateValues=[...prevalues]
    updateValues[currentScene].description.splice(index,1)
    // console.log((updateValues))
    return updateValues
  })

}
// console.log(responseData)
// console.log(dialogs)
  return (
    <Grid container className='istoryContainer' >
      <Header></Header>
      {isLoading && (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      backgroundColor: '#060606',
      flexDirection: 'column',
    }}
  >
    <div className="loading-container">
      {storyCreateFailed ? (
        <>
          <p className="loading-text" style={{ color: '#fdb813', fontSize: '18px', textAlign: 'center' }}>
            Something went wrong while creating your story.
            <br />
            Please try again.
          </p>
          <Button
            sx={{ mt: 2, bgcolor: "#fdb813", color: "#33336f", "&:hover": { bgcolor: "#fdb813" } }}
            variant="contained"
            onClick={() => {
              setLoading(false);
              setStoryCreateFailed(false);
            }}
          >
            Back to Retry
          </Button>
        </>
      ) : (
        <>
          <HoopSpinner size={30} color="#fdb813" />
          <p className="loading-text" style={{ textAlign: 'center' }}>
            Embarking on an AI-Assisted Story Journey...
            <br />
            Please wait. It could take some time.
          </p>
          <Box sx={{ width: '300px', mt: 2 }}>
            <LinearProgress color="secondary" />
          </Box>
        </>
      )}
    </div>
  </div>
)}

      {title.length === 0 && !isLoading && (
        <Box
          sx={{
            display: 'flex',
            flexDirection:"column",
            alignItems: 'center',
            justifyContent: 'center',
            height: "calc(100vh)",
          }}
        >
          <Box>
            <Typography sx={{mb:"20px",fontSize:"48px",fontWeight:600,background:"linear-gradient(to right, #7044ff, #ee3cff, #ff8029) text",WebkitTextFillColor:"transparent"}}>CreativeX</Typography>
          </Box>
          <Box sx={{ textAlign: "center"}}>
            {error && (
              <p style={{ color: "red" }}>{error}</p>
            )}
            <h1>Unleash the Power of AI-Assisted Storytelling</h1>
            <h2>Create Your First Copilot-Enhanced Story and Unleash Your Imagination</h2>
            <Box sx={{display:"flex", flexDirection:"column", gap:"30px"}}>
            <Box sx={{ textAlign: "center" }}>
              <Button 
              sx={{ bgcolor: "#EE3CFF", color: "#fff", "&:hover": { bgcolor: "#EE3CFF", color: "#33336f" } }} 
              variant="contained" onClick={handleOpen}>Sample Campaigns</Button>
            </Box>
            <Box sx={{ textAlign: "center" }}>
              <Button 
              sx={{ bgcolor: "#7044ff", color: "#fff", "&:hover": { bgcolor: "#7044ff", color: "#33336f" } }} 
              variant="contained" onClick={handleCreateOpen}>CreativeX Story</Button>
            </Box>
            </Box>
          </Box>
        </Box>

      )}

      {responseData.length > 0 && title.length > 0 && !isLoading && !error && (
        <Box sx={{minHeight:"100vh"}}>
          <CustomToolbar
            title={responseData[currentScene].title}
            handleOpen={handleOpen}
            handleSaveScene={handleSaveScene}
            previewiStoryBtn={previewiStoryBtn}
            handlePreviewiStory={handlePreviewiStory}
            handleCreateOpen={handleCreateOpen}
            createOpen={creativex}
            home={handlenavigateHome}
          />

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <SceneDisplay
              scene={{
                currentScene: currentScene,
                totalScenes: responseData.length,
                onSceneChange: handleSceneChange,
                scenesData: responseData,
                setScenesData: setResponseData,
                title: responseData[currentScene].title,
                description: responseData[currentScene].description,
                image_caption: responseData[currentScene].image_caption,
                cyoa_image_base64: responseData[currentScene].cyoa_image_base64,
                modifyDialog,
                loader: dialogLoader,
                setDialog,
                dialogChange,
                dialogs,
                voice:lisVoice,
                language:listLanguage,
                selecetdVoice:selecetdVoice,
                setSelectedVoice:setSelectedVoice,
                selectedVoiceChange:selectedVoiceChange,
                selecetdLanguage:selecetdLanguage,
                setSelectedLanguage:setSelectedLanguage,
                selecetdLanguageChange:selecetdLanguageChange,
                
                deleteDialog:deleteDialog
              }}
            />
          </motion.div>
          {/* <Button onClick={save_iStory}>save iStory</Button> */}

        </Box>)}
      {title.length > 0 && responseData.length == 0 && !isLoading && !error && (storyCretionError||!storyCretionError)&&(
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}

        >
          <TitleDisplay
            heading={{
              title: title,
              setTitle:setTitle,
              deleteTitle: deleteTitle,
              addTitle: addTitle,
              titleChange: titleChange,
              titleRegeneration: titleGeneration,
              handleOpen: handleOpen,
              createStory: createStory,
              error:storyCretionError

            }}
          />

        </motion.div>

      )}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
            style: { backdropFilter: 'blur(8px)' }
          },
        }}
      >
        <Fade in={open} >
          <Box sx={style}>

            <Typography sx={{ color: "white" }} variant="h6" component="h2">
              Unveiling Infinite Creativity: Empower Your Story with our Copilot
            </Typography>

            <form onSubmit={titleGeneration}>
              <Box sx={{ mt: 2 }} >
                <label htmlFor="story-intention"
                  style={{
                    color: '#fdb813',
                    transition: 'color 0.3s',
                  }}>
                  Story Intention:
                </label>
                {/* <input
                  type="text"
                  id="story-intention"
                  placeholder="Enter your intention"
                  value={storyIntent}
                  onChange={(e) => setStoryIntent(e.target.value)}
                  onFocus={handleInputFocus}
                  onBlur={handleInputBlur}
                  style={{
                    color: '#FFFFFF',
                    backgroundColor: '#2d2d2d',
                    border: `2px solid ${isInputFocused ? '#1565c0' : '#7e7f81'}`,
                    borderRadius: '4px',
                    padding: '16px',
                    width: '100%',
                    boxSizing: 'border-box',
                    transition: 'border-color 0.3s',
                    outline: 'none'
                  }}
                /> */}
 <select style={{
                    color: '#FFFFFF',
                    backgroundColor: '#2d2d2d',
                    border: `2px solid ${isInputFocused ? '#1565c0' : '#7e7f81'}`,
                    borderRadius: '4px',
                    padding: '16px',
                    width: '100%',
                    boxSizing: 'border-box',
                    transition: 'border-color 0.3s',
                    outline: 'none'
                  }}onChange={(e)=>setTTl(e.target.value)}
                  
                  >
                          <option>Select Your Intention</option>
                          <option>Porsche car campaign</option>
                          <option>Colorful  bouquet shop campaign</option>
                          <option>Types of tea</option>
                </select>
                {/* <TextField
                            label="Story Intention"
                            placeholder="Enter your intention"
                            variant="outlined"
                            value={storyIntent}
                            onChange={(e) => setStoryIntent(e.target.value)}
                            fullWidth
                            InputLabelProps={{ style: { color: '#7e7f81' } }}
                            InputProps={{
                            style: { color: '#FFFFFF' },
                            classes: {
                                root: { '& .MuiOutlinedInput-notchedOutline': { borderColor: '#FFFFFF' } },
                                notchedOutline: { borderColor: '#FFFFFF !important' },
                            },
                            }}
                        /> */}
              </Box>
              <Box sx={{ mt: 2 }}>
                <Button sx={{ bgcolor: "#fdb813", color: "#33336f", "&:hover": { bgcolor: "#fdb813", color: "#33336f" } }} variant="contained" type="submit">Create</Button>
              </Box>
            </form>
          </Box>
        </Fade>
      </Modal>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={creative_open}
        onClose={handleCreativeClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
            style: { backdropFilter: 'blur(8px)' }
          },
        }}
      >
        <Fade in={creative_open} >
          <Box sx={style}>

            <Typography sx={{ color: "white" }} variant="h6" component="h2">
              Unveiling Infinite Creativity: Empower Your Story with our Copilot
            </Typography>

            <form onSubmit={titleCreation}>
              <Box sx={{ mt: 2 }} >
                <label htmlFor="story-intention"
                  style={{
                    color: '#fdb813',
                    transition: 'color 0.3s',
                  }}>
                  Story Intention:
                </label>
                <input
                  type="text"
                  id="story-intention"
                  placeholder="Enter your intention"
                  value={storyIntent}
                  onChange={(e) => setStoryIntent(e.target.value)}
                  onFocus={handleInputFocus}
                  onBlur={handleInputBlur}
                  style={{
                    color: '#FFFFFF',
                    backgroundColor: '#2d2d2d',
                    border: `2px solid ${isInputFocused ? '#1565c0' : '#7e7f81'}`,
                    borderRadius: '4px',
                    padding: '16px',
                    width: '100%',
                    boxSizing: 'border-box',
                    transition: 'border-color 0.3s',
                    outline: 'none'
                  }}
                />
 {/* <select style={{
                    color: '#FFFFFF',
                    backgroundColor: '#2d2d2d',
                    border: `2px solid ${isInputFocused ? '#1565c0' : '#7e7f81'}`,
                    borderRadius: '4px',
                    padding: '16px',
                    width: '100%',
                    boxSizing: 'border-box',
                    transition: 'border-color 0.3s',
                    outline: 'none'
                  }}onChange={(e)=>setTTl(e.target.value)}
                  
                  >
                          <option>Select Your Intention</option>
                          <option>Porsche car campaign</option>
                          <option>Colorful  bouquet shop campaign</option>
                          <option>Types of tea</option>
                </select> */}
                {/* <TextField
                            label="Story Intention"
                            placeholder="Enter your intention"
                            variant="outlined"
                            value={storyIntent}
                            onChange={(e) => setStoryIntent(e.target.value)}
                            fullWidth
                            InputLabelProps={{ style: { color: '#7e7f81' } }}
                            InputProps={{
                            style: { color: '#FFFFFF' },
                            classes: {
                                root: { '& .MuiOutlinedInput-notchedOutline': { borderColor: '#FFFFFF' } },
                                notchedOutline: { borderColor: '#FFFFFF !important' },
                            },
                            }}
                        /> */}
              </Box>
              <Box sx={{ mt: 2 }}>
                <Button sx={{ bgcolor: "#fdb813", color: "#33336f", "&:hover": { bgcolor: "#fdb813", color: "#33336f" } }} variant="contained" type="submit">Create</Button>
              </Box>
            </form>
          </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        // open={restrictionOpen}
        // onClose={RestrictionhandleClose}
        closeAfterTransition
      >
          <Box sx={{...style,textAlign:"center"}}>
            <Typography sx={{ color: "white", mb:2 }} variant='h5'>
            Out of demo credits? Contact us for more.
            </Typography>
            <Button variant='contained' sx={{ bgcolor: "#fdb813", color: "#33336f", "&:hover": { bgcolor: "#fdb813", color: "#33336f" } }}>

              <Box component="a" href="https://arivu-iq.com/#ourContact" target="_blank" sx={{textDecoration:"none"}} >Contact US</Box>
            </Button>
          </Box>
      </Modal>
    </Grid>
  )
}
export default IstoryBoard;